import React, {Component} from 'react';
import {bindActionCreators, compose} from 'redux';
import {connect} from 'react-redux';
import {Redirect, Link, withRouter} from "react-router-dom";
import {withStyles, Typography, Button} from "@material-ui/core";

const styles = theme => ({
    root: {
        zIndex: 1,
    },
    bullets: {
        marginTop: theme.spacing.unit/2,

        '& li:not(:first-child)': {
            marginTop: theme.spacing.unit,
        }
    },
    caption: {
        marginTop: theme.spacing.unit,
    },
});

class Welcome extends Component {

    constructor() {
        super();

        this.state = {
            captive: Welcome.isCaptivePortal(),
        };
    }

    static isCaptivePortal() {
        const {notification, localstorage} = window.Modernizr;
        return !notification && !localstorage;
    }

    render() {
        const {classes, collector} = this.props;

        if (!collector) {
            console.error("No search string specified. Really a WiFi user?");
            return (
                <Redirect to="/" />
            );
        }

        if (this.state.captive) {
            return (
                <div className={classes.root}>
                    <Typography variant="title" paragraph>
                        Öppna din webbläsare för att få tillgång till internet.
                    </Typography>
                </div>
            )
        }

        return (
            <div className={classes.root}>
                <Typography variant="title" paragraph>
                    Välkommen till Pantanova's WiFi!
                </Typography>
                <Typography variant="body1">
                    Genom att använda detta WiFi får du:
                </Typography>
                <Typography variant="body2" component="span">
                    <ul className={classes.bullets}>
                        <li>Fri tillgång till internet på alla Pantanova's WiFi</li>
                        <li>Attraktiva erbjudanden när någon slänger skräp i din närhet</li>
                    </ul>
                </Typography>
                <Typography variant="caption" paragraph className={classes.caption}>
                    Genom att klicka acceptera, godkänner du också Pantanova's <a href="/terms" target="_blank" rel="noopener">villkor</a>.
                </Typography>
                <Button fullWidth variant="raised" color="primary" component={Link} to={"/register/push"}>
                    Acceptera
                </Button>
            </div>
        );
    }
}


const mapStateToProps = (state) => ({
    collector: state.wifi.search,
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default compose(
    withRouter,
    withStyles(styles, {withTheme: true}),
    connect(mapStateToProps, mapDispatchToProps),
)(Welcome);



// WEBPACK FOOTER //
// ./src/containers/Welcome.js